import React from 'react';

/**
 * Малюнки до розділу «З чого почати».
 *
 * Ситуації позначалися піктограмами Font Awesome — людина, сітка, трикутник
 * з окликом, календар, щит, пазл. Три з них уже стояли в інших місцях сайту
 * під іншим змістом: та сама «сітка» позначала і відкриття клініки, і послугу
 * реєстрації, а «щит» — і перевірку органу, і захист торговельної марки.
 *
 * Тут малюнок під кожну ситуацію окремо: вихід із найму, будівля клініки,
 * відмова з печаткою, прострочений календар, перевірка з лупою, точкове
 * питання. Техніка та сама, що й у ServiceGlyph — лінії просто в розмітці,
 * колір із тексту.
 *
 * Розмір навмисно менший за малюнки послуг, і без плашки під ними: розділи
 * стоять один за одним, і якби вони були оформлені однаково, сторінка знову
 * читалася б як два однакові блоки поспіль.
 */

const Frame = ({ children, className }) => (
  <svg
    viewBox="0 0 64 64"
    className={className}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    {children}
  </svg>
);

// 01. Вихід із найму в приватну практику — відчинені двері й вихід із них.
const Exit = () => (
  <>
    <path d="M10 56V14a4 4 0 0 1 4-4h16v46" />
    <path d="M6 56h28" />
    <circle cx="25" cy="33" r="1.7" fill="currentColor" stroke="none" />
    <path d="M40 33h16M50 27l6 6-6 6" />
  </>
);

// 02. Відкриття клініки з нуля — будівля з медичним хрестом.
const Clinic = () => (
  <>
    <path d="M12 56V26L32 12l20 14v30" />
    <path d="M6 56h52" />
    <path d="M32 28v12M26 34h12" />
    <path d="M26 56V46h12v10" />
  </>
);

// 03. Відмова в отриманні ліцензії — бланк із перекресленою печаткою.
const Refusal = () => (
  <>
    <path d="M12 6h26l10 10v26a4 4 0 0 1-4 4H12a4 4 0 0 1-4-4V10a4 4 0 0 1 4-4Z" />
    <path d="M38 6v8a2 2 0 0 0 2 2h8" />
    <path d="M16 22h20M16 29h14" />
    <circle cx="42" cy="44" r="10" />
    <path d="m38 40 8 8M46 40l-8 8" />
  </>
);

// 04. Не подані Відомості — календар із простроченим строком.
const Overdue = () => (
  <>
    <rect x="8" y="12" width="48" height="44" rx="4" />
    <path d="M8 25h48M20 6v11M44 6v11" />
    <path d="M32 33v10" />
    <circle cx="32" cy="48" r="1.8" fill="currentColor" stroke="none" />
  </>
);

// 05. Перевірка контролюючого органу — акт під лупою.
const Inspection = () => (
  <>
    <path d="M44 26V14a4 4 0 0 0-4-4H14a4 4 0 0 0-4 4v36a4 4 0 0 0 4 4h16" />
    <path d="M22 6h10a2 2 0 0 1 2 2v4H20V8a2 2 0 0 1 2-2Z" />
    <path d="M18 24h18M18 32h10" />
    <circle cx="42" cy="42" r="10" />
    <path d="m49 49 7 7" />
  </>
);

// 06. Точкове питання — приціл на одній точці, а не весь цикл робіт.
const Pinpoint = () => (
  <>
    <circle cx="32" cy="32" r="19" />
    <circle cx="32" cy="32" r="9" />
    <circle cx="32" cy="32" r="2.4" fill="currentColor" stroke="none" />
    <path d="M32 5v8M32 51v8M5 32h8M51 32h8" />
  </>
);

const GLYPHS = [Exit, Clinic, Refusal, Overdue, Inspection, Pinpoint];

const SituationGlyph = ({ index, className = 'w-12 h-12' }) => {
  const Glyph = GLYPHS[index] || GLYPHS[0];
  return (
    <Frame className={className}>
      <Glyph />
    </Frame>
  );
};

export default SituationGlyph;
